const api = [
  'api/User/GetUserMenuSettings',
  'api/Auth/Logout',
  'api/Call/Create',
  'api/Call/Update',
  'api/Call/CompleteCall',
  'api/Call/GetCallSummary',
  'api/Call/GetCallParticipantInfo',
  'api/ThreeWayCall/RedialOutbound',
  'api/Room/IsRoomCreated',
  'api/Operator/ChangeCurrentStatus',
  'api/Operator/StartInitiated',
  'api/Operator/FilterOperator',
  'api/Tin/GetUserTinById',
  'api/Tin/IsTinExists',
];

const sensitiveApi = [
  'api/Auth/WebToken',
  'api/Auth/Login',
  'api/Auth/externalLogin',
];

export const LogConfig = {
  allowed: {
    api,
  },
  sensitive: {
    api: sensitiveApi,
  },
};
